import { ViewStyle } from 'react-native';

import { getFont, getBorderRadius } from '@24i/nxg-sdk-higgs';
import { getTelegramWebApp } from '@24i/nxg-sdk-higgs/src/utils';
import { Theme } from '@24i/nxg-sdk-photon';
import { useDimensions } from '@24i/nxg-sdk-quantum';

import { SliderStyles } from './types';
import { Breakpoint } from '../../../utils/styles/constants';

const Slider = (theme: Theme): SliderStyles => {
    const { isLandscape } = useDimensions();

    return {
        item: {
            backgroundColor: 'transparent',
            alignSelf: 'stretch',
            width: '100%',
            height: '66%',
        },
        image: {
            width: '100%',
            height: '66%',
        },
        dynamicLandscapeImage: {
            display: isLandscape ? 'flex' : 'none',
        },
        dynamicPosterImage: {
            display: isLandscape ? 'none' : 'flex',
        },
        slideHolder: {
            width: '100%',
            alignSelf: 'center',
        },
        slideContainer: {
            flex: 1,
            flexDirection: 'column-reverse',
            marginTop: 12,
            marginRight: '1%',
            aspectRatio: isLandscape ? 16 / 9 : 2 / 3,
            transformOrigin: 'center bottom',
            transition: !isLandscape ? 'height 999s, max-height 999s' : '0.1s ease-in',
            [`@media (max-width: ${Breakpoint.SM}px)`]: {
                marginTop: 0,
            },
            ':hover': {
                transform: getTelegramWebApp() ? 'none' : 'scale(1.02)',
                zIndex: 2,
                [`@media (max-width: ${Breakpoint.SM}px)`]: {
                    marginTop: 0,
                },
            },
        } as ViewStyle,
        imageStyleContainer: {
            position: 'relative',
            height: '100%',
            width: '100%',
        },
        imageStyle: {
            flex: 1,
            backgroundColor: 'transparent',
            width: '100%',
            borderRadius: 6,
            ...getBorderRadius(theme.elements, 'headerTile-cornerRadius'),
            overflow: 'hidden',
            zIndex: 0,
        },
        itemText: {
            textAlign: 'left',
            ...getFont(theme, 'h2'),
            color: '#fff',
        },
        textHolder: {
            position: 'absolute',
            bottom: 40,
            left: 32,
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            zIndex: 2,
            [`@media (max-width: ${Breakpoint.XL}px)`]: {
                left: 20,
                bottom: 30,
            },
            [`@media (max-width: ${Breakpoint.MD}px)`]: {
                bottom: 20,
            },
        },
        buttonsHolder: {
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 17,
        },
        titleViewHolder: {
            width: '85%',
        },
        gradient: {
            position: 'absolute',
            height: '100%',
            width: '100%',
            zIndex: 1,
            //  @ts-ignore
            background: theme.color.gradient2.color,
        },
        primaryButtonContainerWithTitle: {
            height: 52,
            width: 'auto',
            paddingLeft: 20,
            paddingRight: 25,
        },
        additionalSubactionButtonContainerStyles: {
            width: 42,
            paddingLeft: 0,
            paddingRight: 0,
            '@media (max-width: 1200px)': {
                width: 40,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
        assetLabelContainer: { alignSelf: 'flex-start' },
        itemContainer: {
            transition: '0.1s ease-in',
            ':hover': {
                marginTop: getTelegramWebApp() ? '12' : 'calc(-0.4%)',
                marginBottom: getTelegramWebApp() ? 'auto' : 'calc(0.4%)',
                transform: getTelegramWebApp() ? 'none' : 'scale(1.02)',
            },
        } as ViewStyle,
        geoBlockIconContainer: {
            position: 'absolute',
            top: 34,
            right: 34,
            backgroundColor: theme.color.labelSecondary,
            zIndex: 10,
            height: 'auto',
            width: 'auto',
            padding: 2,
            borderRadius: 2,
        },
    };
};
export default Slider;
